import obj_slice from 'sugar/object/select'

export default{
  methods: {
    // filtered_people = filter_duplication_entities(@people, registration.person_id, 'participant')
    filter_duplication_entities(entities, selected_id, type) {
      let blank_params = ['first_name', 'last_name']
      let slice_params
      switch (type) {
        case 'participant':
          slice_params = ["first_name", "last_name", "birth_date"]
          break;
        case 'parent':
          slice_params = ["first_name", "last_name", "email"]
          break;
        case 'doctors':
          slice_params = ["first_name", "last_name", "email", "work_phone"]
          break;
        case 'emergency':
          slice_params = ["first_name", "last_name", "email", "cell_phone", "home_phone", "work_phone"]
          break;
        case 'address':
          blank_params = ["address_line1", "city", "state", "zip_code"]
          slice_params = ["address_line1", "city", "state", "zip_code"]
          break;
        case 'insurance':
          blank_params = ["carrier", "group_number"]
          slice_params = ["carrier", "group_number"]
          break;
      }

      if (!["address", "insurance"].includes(type)) {
        for (const p of entities) {
          if (p.first_name) p.first_name = p.first_name.charAt(0).toUpperCase() + p.first_name.slice(1)
          if (p.last_name) p.last_name = p.last_name.charAt(0).toUpperCase() + p.last_name.slice(1)
        }
      }

      let new_map={}
      let selected_key = null
      for (const el of entities){
        const el_params = obj_slice(el, slice_params)
        const key = JSON.stringify(el_params)

        if (el.id === selected_id || (this.rel_object && el.id === this.rel_object.relation_id)){
          new_map[key] = el
          selected_key = key
          continue;
        }
        if (selected_key === key) {
          continue;
        }else if (this.isBlank(Object.values(obj_slice(el, blank_params)).join(""))){
          // just stub
        }else{
          const existing = new_map[key]
          if (existing){
            if (existing.updated_at_int && existing.updated_at_int < el.updated_at_int){
              new_map[key] = el
            }else{
              // do nothing as we have newest obj
            }
          }else{
            new_map[key] = el
          }
        }
      }
      // arr_remove(entities, (el) => {
      //   if (el.id === selected_id) return false;
      //
      //   if (this.isBlank(Object.values(obj_slice(el, blank_params)).join(""))) {
      //     return true;
      //   } else {
      //     let el_params = obj_slice(el, slice_params)
      //     let similar = entities.filter((a) =>  obj_equal(obj_slice(a, slice_params), el_params) )
      //
      //     if (similar.length >= 2) {
      //       let person = similar.sort((a, b) => a.updated_at_int - b.updated_at_int)[-1]
      //       if (person !== el) return true
      //     }
      //   }
      // })

      // entities = entities.sort((a,b)=> b.updated_at_int-a.updated_at_int)
      return Object.values(new_map).sort((a,b)=> b.updated_at_int-a.updated_at_int)
    },
  }
}